/*
  Usage:

    Purpose:
      Allows menu hide / shrink actions by addin classes to .header element:
        - header--sticky   - added when we're not at the top of the page
        - header--stickyUp - added when we're not at the top but we're scrolling up
      Uses scroll event throttling for lower CPU usage, and delay for detection when
      we're at the top for the same reason

    Args:
      none

    Example:
      none
*/

import { throttle } from '../vendors/helpers/throttle';


export default class Header
{
  constructor(debug = false)
  {
    this.debug = debug;
    if (this.debug) console.log('Header init');

    if (!this.setVars()) return;
    this.setEvents();

    if (this.debug) console.log('Header succesful');
  }

  setVars()
  {
    this.TOP_DETECTION_INTERVAL = 500;
    this.THROTTLE_DELAY         = 50;
    this.MINIMUM_DELTA            = 50;

    this.lastScrollTop        = window.scrollY;
    this.lastBusyScrollTop    = window.scrollY;
    this.scrollingUp          = false;

    this.header = document.querySelector('.header');
    if (!this.header) return;

    this.classes = {
      sticky:   'header--sticky',
      stickyUp: 'header--stickyUp',
    };

    return true;
  }

  setEvents()
  {
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.detectScrollDirectionAndGo();

        window.addEventListener('scroll', throttle(() => {
          this.detectScrollDirectionAndGo();
          // if (this.debug) console.info('Header throttling...', new Date().toUTCString());
        }, this.THROTTLE_DELAY));
      }, 0);
    });

    this.setupTopDetectionIntervalFuncion();
  }

  setupTopDetectionIntervalFuncion()
  {
    setInterval(() => {
      const scrollDelta = window.scrollY - this.lastBusyScrollTop;

      this.minimizeHeaderIfNotOnTop(scrollDelta);
      this.maximizeHeaderIfOnTop(scrollDelta);

      this.lastBusyScrollTop = window.scrollY;

    }, this.TOP_DETECTION_INTERVAL);
  }

  maximizeHeaderIfOnTop(scrollDelta)
  {
    if (window.scrollY === 0 && scrollDelta === 0
      && this.header.classList.contains(this.classes.sticky)) {

      this.header.classList.remove(this.classes.sticky);
    }
  }

  minimizeHeaderIfNotOnTop(scrollDelta)
  {
    if (window.scrollY !== 0 && scrollDelta === 0) {

      if (!this.header.classList.contains(this.classes.sticky) && window.scrollY !== 0) {
        this.header.classList.add(this.classes.sticky);
      }
    }
  }

  detectScrollDirectionAndGo()
  {
    const currentScrollTop = window.scrollY;
    const scrollDelta = currentScrollTop - this.lastScrollTop;

    // show top menu on scroll up
    if (scrollDelta > 0 && scrollDelta > this.MINIMUM_DELTA) {

      this.header.classList.remove(this.classes.stickyUp);
      this.header.classList.add(this.classes.sticky);
      this.scrollingUp = false;
    }
    else if (Math.abs(scrollDelta) > this.MINIMUM_DELTA) {

      this.header.classList.add(this.classes.stickyUp);
      this.scrollingUp = true;
    }

    if (this.debug) console.log('Header - going', this.scrollingUp ? ' up ' : ' down ');

    this.lastScrollTop = currentScrollTop;
  }
}
